import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  PresaleCheckoutPage,
  presaleCheckoutSearchSchema,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleCheckoutSearchSchema.shape,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/checkout")({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  return <PresaleCheckoutPage search={Route.useSearch()} />;
}
